const ROUTES = {
  HOME: '/',
  TOKEN_LOGIN: '/token-login',
  CONTRACTS: 'contracts',
  ORDERS: 'orders',
  LOGIN: '/login',
  PASSWORD_RECOVERY: '/password-recovery',
};

export default ROUTES;
